import { useState } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import SkeletonLoading from "@components/skeleton";

const LazyLoadImageComponent = (props) => {
  const [loadingImg, setLoadingImg] = useState(false);

  return (
    <>
      {loadingImg && <SkeletonLoading className="w-100 h-100" />}
      <LazyLoadImage
        {...props}
        height="100%"
        width="100%"
        beforeLoad={() => setLoadingImg(true)}
        afterLoad={() => setLoadingImg(false)}
        className={`${props.className ? props.className : ""}  ${
          loadingImg ? "invisible" : ""
        }`}
      />
    </>
  );
};

export default LazyLoadImageComponent;
